import * as React from 'react';
import { useParams } from 'react-router-dom';
import { FlightDetails } from '../containers';

export const FlightDetailsPage: React.FC = () => {
  const params = useParams<{ id: string }>();
  const ids = params.id.split('/');

  return (
    <React.Fragment>
      {ids.map((id, index) => (
        <FlightDetails key={index} id={id} />
      ))}
    </React.Fragment>
  );
};
